import { useEffect, useSyncExternalStore } from "react";

/**
 * Topbar slot – lets a page temporarily replace the route title in the app topbar
 * (e.g. a condensed record identity once its own header has scrolled out of view).
 * Tiny external store so the shell and pages stay decoupled.
 */
let slot = null;
const listeners = new Set();
const emit = () => listeners.forEach((l) => l());

export const topbar = {
  set(node) {
    slot = node;
    emit();
  },
  get() {
    return slot;
  },
  subscribe(l) {
    listeners.add(l);
    return () => listeners.delete(l);
  },
};

/** Shell: current override node (or null → default route title). */
export const useTopbarSlot = () => useSyncExternalStore(topbar.subscribe, topbar.get, () => null);

/** Pages: show `node` in the topbar while `active`; cleared automatically on unmount. Memoise `node`. */
export const useTopbar = (node, active = true) => {
  useEffect(() => {
    topbar.set(active ? node : null);
    return () => topbar.set(null);
  }, [node, active]);
};
